import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { NavContext } from "../../../state/NavContext";
import { Image, Col, Skeleton, Divider, Typography, Row, Space, notification } from "antd";
import axios from "axios";
import Title from "antd/lib/typography/Title";
import { StarFilled } from "@ant-design/icons";

const { Paragraph, Text } = Typography;

const MovieDetail = () => {
  const { id } = useParams();
  const [movie, setMovie] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("movies");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  useEffect(() => {
    if (!isLoaded) {
      axios
        .get(`https://backendexample.sanbersy.com/api/data-movie/${id}`)
        .then((res) => {
          setMovie(res.data);
          setIsLoaded(true);
        })
        .catch((err) => {          
          notification.error({
            message: "Error Loading Data",
            description: err.response.data.message,
            placement: "topRight",
          });
          console.log(err.response.data.message);
          setIsLoaded(true);
        });
    }
  }, []);

  useEffect(() => {
    setActiveIndex("movies");
  }, [setActiveIndex]);

  return (
    <div className="movie-detail-card">
      <Row>
        <Col span={5} xs={24} sm={24} md={5} lg={5}>
          <Image
            width="100%"
            height={250}
            style={{ objectFit: "cover" }}
            src={
              movie.image_url
                ? movie.image_url
                : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAA1BMVEXR0dFCxnTBAAAASElEQVR4nO3BgQAAAADDoPlTX+AIVQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwDcaiAAFXD1ujAAAAAElFTkSuQmCC"
            }
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAA1BMVEXR0dFCxnTBAAAASElEQVR4nO3BgQAAAADDoPlTX+AIVQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwDcaiAAFXD1ujAAAAAElFTkSuQmCC"
          />
        </Col>
        <Col span={18} xs={24} sm={24} md={18} lg={18} offset={1}>
          {isLoaded ? (
            <Title level={2}>
              {movie.title} ({movie.year})
            </Title>
          ) : (
            <Skeleton active paragraph={false} loading={true} title={true} />
          )}
          <Divider />
          {isLoaded ? (
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row>
                <Col span="6">
                  <Text>Year:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">{movie.year}</Text>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Text>Duration:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">{movie.duration} minutes</Text>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Text>Genre:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">{movie.genre}</Text>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Text>Rating:</Text>
                </Col>
                <Col span="18">
                  <StarFilled style={{ color: "gold" }} />
                  <Text type="secondary"> {movie.rating}/10</Text>
                </Col>
              </Row>
            </Space>
          ) : (
            <Skeleton active paragraph={true} loading={true} />
          )}
        </Col>
      </Row>
      <div className="detail">
        <Divider orientation="center">Description</Divider>
        {isLoaded ? (
          <Paragraph>{movie.description}</Paragraph>
        ) : (
          <Skeleton active />
        )}
        <Divider orientation="center">Review</Divider>
        {isLoaded ? <Paragraph>{movie.review}</Paragraph> : <Skeleton active />}
      </div>
    </div>
  );
};

export default MovieDetail;
